import React, { Component } from 'react';
/* eslint-disable */
import axios from 'axios';
import { MY_API_URL } from '../../Apanel/QueryMe';
import swal from 'sweetalert';
import Resizer from 'react-image-file-resizer';
import { Button, Card, CardBody, Col, Badge, Table } from 'reactstrap';
import Alert from '../../../shared/components/Alert';
const apiurl = MY_API_URL;
const dimgurl = apiurl + 'ava.png';
const initialstate = {
	asettings: [],
	showAlert: false,
	alertType: '',
	alertText: '',
	failbtn: false,
	logo: localStorage.logo,

	token: localStorage.token,
};
class Asettings extends Component {
	constructor (props) {
		super(props);
		this.base64Image = this.base64Image.bind(this);
	}
	state = { ...initialstate };
	componentDidMount() {
		localStorage.setItem('viewrecruiter', '');
		localStorage.setItem('gotodash', 0);
		if (localStorage.profile_completed === '0') {
			localStorage.setItem('came_from', 'Asettings');
			this.props.history.push({
				pathname: '/profile',
				backTo: '/',
			});
		} else {
			// this.handleGetSettings(localStorage.token);
		}
	}
	updatelogo = () => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		let tutu = 'updatelogo';

		const addkeyurl = apiurl + tutu;
		var postData = {
			email: localStorage.by,
			logo: this.state.logo,
		};
		axios
			.post(addkeyurl, postData, {
				headers: headers,
			})
			.then((response) => {
				console.log(response.data.message);
				if (response.data.error) {
					this.setState({
						showAlert: true,
						alertType: 'warning',
						alertText: response.data.message,
					});
				} else {
					this.setState(
						{
							showAlert: true,
							alertType: 'success',
							alertText: response.data.message,
						},
						() => {
							localStorage.setItem('logo', this.state.logo);
						},
					);
				}
			})
			.catch((error) => {
				console.log('Error is ', error);
				this.setState({
					alertType: 'danger',
					showAlert: true,
					alertText: 'Failed Try Again Later!',
				});
			});
	};

	getImageType(giventype) {
		var type = '';

		switch (giventype) {
			case 'image/png':
				type = 'PNG';
				break;
			case 'image/gif':
				type = 'JPEG';
				break;
			case 'image/jpeg':
				type = 'JPEG';
				break;
			case 'image/jpg':
				type = 'JPEG';
				break;
			default:
				type = 'JPEG';
				break;
		}
		return type;
	}
	base64Image(event) {
		if (event.target.files[0]) {
			var mig = event.target.files[0];
			console.log('gottype', event.target.files[0].type);
			var gottype = this.getImageType(event.target.files[0].type);

			console.log('gottype', gottype);
			this.setState(
				{
					failbtn: true,
				},
				() => {
					console.log(this.state.logo);
					var fileInput = false;
					if (mig) {
						fileInput = true;
					}
					if (fileInput) {
						Resizer.imageFileResizer(
							mig,
							136,
							36,
							gottype,
							100,
							0,
							(uri) => {
								console.log('uri', uri);


								this.setState(
									{
										showAlert: false,
										logo: uri,
										failbtn: false,
									},
									() => {
										localStorage.setItem('logo', this.state.logo);
									},
								);
							},
							'base64',
						);
					}
				},
			);
		}
	}

	handleGetSettings = (token) => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			cemail: localStorage.by,
		};
		const getuurl = apiurl + 'asettings';
		axios
			.post(getuurl, postData, {
				headers: headers,
			})
			.then((response) => {
				if (response.data.error) {
				} else {
					this.setState({
						asettings: [...response.data.data],
					});
				}
			})
			.catch((error) => {
				// localStorage.clear();
				this.props.history.push('/');
			});
	};

	render() {
		const { logo, failbtn, showAlert, alertType, alertText } = this.state;
		return (
			<Col md={12}>
				<Card>
					<CardBody>
						<div className="card__title">
							<h5 className="bold-text">Company Settings</h5>
							{this.state.showAlert ? (
								<Alert color={this.state.alertType}>
									<p>{this.state.alertText}</p>
								</Alert>
							) : null}
						</div>
						<Table responsive hover>
							<thead>
								<tr>
									<th>White Lable Logo on Reports</th>
									<th>Manage</th>
									<th>{''}</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										<img
											src={logo}
											className="img-responsive"
											style={{ width: '136px' }}
											alt="Logo"
										/>
									</td>

									<td>
										<div className="form__form-group-field">
											<input type="file" onChange={this.base64Image} />
										</div>
										<div>
											<br />
											width: 135px X height:35px{' '}
										</div>
									</td>
									<td>
										<button
											className="btn btn-primary account__btn account__btn--small"
											onClick={this.updatelogo}
											disabled={failbtn}
										>
											Update Logo
										</button>
									</td>
								</tr>
							</tbody>
						</Table>
					</CardBody>
				</Card>
			</Col>
		);
	}
}

export default Asettings;
